import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { WorkStationCheckinModal } from './components/WorkStationCheckinModal';
import { useWorkStationCheckinVisibility } from './hooks/useWorkStationCheckinVisibility';
import { profileTypes } from '../../config/constants/userConstants';

const WorkStationCheckinController = () => {
  const currentUser = useSelector((state) => state.auth?.currentUser);
  const { isVisible, markCheckedIn, closeModal } = useWorkStationCheckinVisibility({
    show: currentUser?.profile?.idProfile === profileTypes.OPERATOR.id,
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isVisible) setIsOpen(true);
  }, [isVisible]);

  const handleClose = () => {
    closeModal();
    setIsOpen(false);
  };

  return isOpen ? <WorkStationCheckinModal show onSave={markCheckedIn} onClose={handleClose} /> : null;
};

export { WorkStationCheckinController };
